import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import { InfoOutlined } from '@mui/icons-material';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()({
  verified: {
    color: '#1AAE4E',
    marginRight: '5px',
  },
  unverified: {
    color: '#FFA34A',
    marginRight: '5px',
  },
});

export default function VerificationStatusIcon({
  isVerified = false,
}: {
  isVerified: boolean;
}) {
  const { classes } = useStyles();

  return isVerified ? (
    <CheckCircleOutlineIcon className={classes.verified} />
  ) : (
    <InfoOutlined className={classes.unverified} />
  );
}
